import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

// 定义用户类型
export interface User {
  id: number
  username: string
  role: string
  [key: string]: any
}

// 使用 setUp 方式定义 store
export const useUserStore = defineStore('user', () => {
  // 从localStorage初始化状态
  const token = ref<string | null>(localStorage.getItem('token') || null)
  const user = ref<User | null>(null)
  
  // 尝试从localStorage解析用户数据
  try {
    const userStr = localStorage.getItem('user')
    if (userStr) {
      const userData = JSON.parse(userStr)
      user.value = userData
      console.log('用户store初始化 - 已从localStorage加载用户数据:', userData.username)
    }
  } catch (e) {
    console.error('用户store初始化 - 解析用户数据出错:', e)
    // 如果解析失败，清除localStorage
    localStorage.removeItem('user')
    localStorage.removeItem('token')
  }
  
  const isLoggedIn = computed(() => {
    const result = !!token.value && !!user.value
    console.log('isLoggedIn计算:', result, {token: !!token.value, user: !!user.value})
    return result
  })
  
  const isAdmin = computed(() => user.value?.role === 'admin')
  
  function login(newToken: string, newUser: User) {
    console.log('Store login called with token:', newToken.substring(0, 10) + '...', 'user:', newUser.username)
    token.value = newToken
    user.value = newUser
    
    // 同步到localStorage
    localStorage.setItem('token', newToken)
    localStorage.setItem('user', JSON.stringify(newUser))
    
    // 日志记录登录状态
    console.log('登录后状态:', { tokenSet: true, userSet: true, isLoggedIn: isLoggedIn.value })
  }
  
  function logout() {
    console.log('Store logout called')
    token.value = null
    user.value = null
    
    // 同步到localStorage
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    
    // 日志记录登出状态
    console.log('登出后状态:', { tokenSet: false, userSet: false, isLoggedIn: isLoggedIn.value })
  }
  
  return {
    token,
    user,
    isLoggedIn,
    isAdmin,
    login,
    logout
  }
}) 